import React, { useState, useEffect } from "react";
import BackNavigationPanel from "../../../../../ui/back-navigation-panel/BackNavigationPanel";
import MenuTable from "../../../../../ui/menu-table/MenuTable";
import { EmailTypes, UpdateEmailNotificationStatusRequest, UpdateEmailNotificationStatusResponse } from "../../../../../../utils/grpc/generated/Billsby.Protos/Messenger/private/companyconfig/companyconfig_pb";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../../../..";
import { updateEmailNotificationToggles, fetchEmailNotificationToggles } from "../../../../../../actions/emailRoutingActions";
import { useHistory } from "react-router";


const TrialManagementMenu: React.FC = () => {
  const emailNotificationToggles = useSelector((state: AppState) => state.emailRoutingReducer.emailNotificationToggles);
  const currentCompanyId = useSelector((state: AppState) => state.auth.currentCompanyId);

  const dispatch = useDispatch<Function>();
  const history = useHistory();
 
  const [switchState, setSwitchState] = useState({
    _72HoursBeforeTrialExpire: false
  });

  const updateData = async (updateEmailNotification: UpdateEmailNotificationStatusRequest) => {
    try {
      await (dispatch(updateEmailNotificationToggles(updateEmailNotification)) as { response: UpdateEmailNotificationStatusResponse });
      dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
    }
    catch (err) { }
  }

  useEffect(() => {
    if (emailNotificationToggles.getEmailNotificationConfigsList().length) {
      let newState: any = {};
      emailNotificationToggles.getEmailNotificationConfigsList().forEach((elem) => {
        switch (elem.getEmailType()) {
          case EmailTypes.REMINDER_72_HOURS_BEFORE_TRIAL_EXPIRES:
            newState._72HoursBeforeTrialExpire = elem.getIsEnabled();
            break;
        }
      })
      setSwitchState(newState);
    }
  }, [emailNotificationToggles]);

  useEffect(() => {
    dispatch(fetchEmailNotificationToggles(Number(currentCompanyId)));
  }, []);


  return (
    <div>
      <BackNavigationPanel
        title={"EMAILS_MENU_SUBSCRIPTION_LIFECYCLE_TRIAL_MANAGEMENT"} shouldTranslateTitle={true}
        onClick={() => history.push("/configuration/email-notifications/emails")}>
        <MenuTable
          data={[
            {
              title: "EMAILS_MENU_SUBSCRIPTION_LIFECYCLE_TRIAL_MANAGEMENT_72_HOURS_BEFORE_TRIAL_EXPIRY",
              onClick: () => history.push("/configuration/email-notifications/emails/trial-management/trial-will-expire-in-three-days-template"),
              canConfigureNotification: true,
              enableNotification: switchState._72HoursBeforeTrialExpire,
              enableNotificationChange: (isChecked) => {
                setSwitchState({ ...switchState, _72HoursBeforeTrialExpire: isChecked });
                const updateEmailNotification = new UpdateEmailNotificationStatusRequest();
                updateEmailNotification.setCompanyId(Number(currentCompanyId));
                updateEmailNotification.setEmailType(EmailTypes.REMINDER_72_HOURS_BEFORE_TRIAL_EXPIRES);
                updateEmailNotification.setIsEnabled(isChecked);
                updateData(updateEmailNotification);
              }
            }
            // {
            //   title: 'EMAILS_MENU_SUBSCRIPTION_LIFECYCLE_TRIAL_MANAGEMENT_WHEN_A_TRIAL_IS_EXTENDED',
            //   onClick: () => history.push('/configuration/email-notifications/emails/welcome-emails/new-subscription-with-trial-template')
            // }
          ]}
        />
      </BackNavigationPanel>
    </div>
  )
}

export default TrialManagementMenu;
